import { gql, useQuery } from "@apollo/client";
import { type Address, BillingMode, type Query } from "elephant-web/gql";

export const MY_CLINIC = gql`
  query myClinic {
    myClinic {
      uuid
      name
      organisation
      addresses {
        country
        state
        subCounty
        ward
        street
      }
      settings {
        billingMode
      }
    }
  }
`;

export interface UserFacility {
  id: string;
  name: string;
  organisation: string;
  address: Address;
  billingMode: BillingMode;
}

function transformFacilityData(
  myClinic: NonNullable<Query["myClinic"]>,
): UserFacility {
  return {
    id: myClinic.uuid,
    name: myClinic.name,
    organisation: myClinic.organisation,
    address: myClinic.addresses[0],
    billingMode: myClinic.settings?.billingMode ?? BillingMode.PostService,
  };
}

export default function useFacility() {
  const { data, ...rest } = useQuery<Pick<Query, "myClinic">>(MY_CLINIC, {
    fetchPolicy: "cache-first",
  });

  return {
    data: data?.myClinic && transformFacilityData(data.myClinic),
    ...rest,
  };
}
